import { orderService } from '../../helpers/orderservice/order.service';
import router from '../../router/index'
import Swal from 'sweetalert2';

const user = JSON.parse(localStorage.getItem('user'));

function getMount(items){
    let valor = 0
    if(items != undefined)
        if(items.length > 0){
            for(let i=0; i<items.length; i++){
                valor = valor + (items[i].precio * items[i].quantity)
            }
        }
    return parseFloat(valor.toFixed(2))
}

function getPropina(order){
    let valor = 0

    if(order.items != undefined){
        if(order.items.length > 0){
            for(let i=0; i<order.items.length; i++){
                valor = valor + (order.items[i].precio * order.items[i].quantity)
            }
        }
    }
    valor = parseFloat((valor*0.10).toFixed(0))

    if(order.terminate){
        if(order.propina){
            if(order.propinaVariable){
                valor = parseFloat(order.propinaAmount)
            }
        }
    }
    return valor
}

function calculateInfoToday(orders){
    let aux = {
        totalAmount: 0,
        propinaAmount: 0,
    }
    for(let i=0; i<orders.length; i++){
        if(orders[i].terminate){
            console.log("TotalAmount:",aux.totalAmount)
            aux.totalAmount += parseFloat(getMount(orders[i].items))
            if(orders[i].propina)
                aux.propinaAmount += parseFloat(getPropina(orders[i]))
        }
    }
    console.log("TotalAmountFinal:",aux.totalAmount)
    return aux
}

function normalizeOrders(orders){
    if(Array.isArray(orders)){
        return orders
    }

    if(orders && Array.isArray(orders.items)){
        return orders.items
    }

    if(orders && Array.isArray(orders.orders)){
        return orders.orders
    }

    if(orders && typeof orders === 'object'){
        return Object.values(orders)
    }

    return []
}

export const state = user
    ? 
        { 
            status: { loggeduser: true }, 
            orders:[], 
            itemsMenu:[], 
            client:{
                nit:"",
                nameClient:"",
                addressClient:""
            },
            resultPayment:{},
            payOrder:{},
            todayInfo:{
                totalAmount: 0,
                propinaAmount: 0,
            },
            loadingFlag:false,
            itemToUpdate:{}
        }
    : 
        { 
            status: {}, 
            user: null, 
            orders:null, 
            itemsMenu:null, 
            cient:null, 
            resultPayment:null, 
            payOrder:null, 
            todayInfo:null, 
            loadingFlag:false,
        };

export const getters = {
    // Whether the user is currently logged in.
    allOrders(state) {
        return state.orders
    },
    menuList(state){
        return state.itemsMenu
    },
    orderToPay(state){
        console.log(state.payOrder)
        return state.payOrder
    },
    infoClient(state){
        return state.client
    },
    paymentInfo(state){
        return state.resultPayment
    },
    todayInfo(state){
        return state.todayInfo
    },
    loadingFlag(state){
        return state.loadingFlag
    },
}

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    orders({ dispatch, commit },{bodyFind, silent = false}) {
        //commit('loginRequest', { email });
        if(!silent){
            commit('setLoading', true)
            commit('ordersRequest', []);
        }
        orderService.activesByDate(bodyFind)
            .then(
                orders => {
                    const orderList = normalizeOrders(orders)
                    commit('ordersRequest', orderList);
                    console.log(orderList)
                    let infoTodayDo = calculateInfoToday(orderList)
                    console.log(infoTodayDo)
                    commit('updateInfoToday', infoTodayDo);
                    //router.push('/');
                    if(!silent){
                        commit('setLoading', false)
                    }
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    router.push('/login');
                    if(!silent){
                        commit('setLoading', false)
                    }
                }
            );
    },
    newOrder({dispatch,commit}, orderData = {}){
        return orderService.newOrder(orderData)
            .then(
                result => {
                    if(result && result.valid === false){
                        Swal.fire("No se pudo crear", result.msg || "Intenta nuevamente.", "warning");
                        return result
                    }
                    commit('ordersRequestNew', result.orders)
                    return result
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    router.push('/login');
                    throw error
                }
            )
    },
    itemsMenu({dispatch,commit}){
        orderService.itemsMenu()
            .then(
                result => {
                    console.log(result)
                    commit('itemsMenuList', result)
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    router.push('/login');
                }
            )
    },
    setItemsMenu({commit}, items ){
        console.log(items)
        commit('itemsMenuList', items)
    },
    addItemToOrden({dispatch, commit}, {idOrden,idItem,observations,table,promotion}){
        return orderService.addItemMenuToOrden(idOrden,idItem,observations,table,promotion)
            .then(
                result => {
                    if(result && result.valid === false){
                        Swal.fire("No se pudo agregar", result.msg || "Intenta nuevamente.", "warning");
                        return result
                    }
                    const orderList = normalizeOrders(result.orders)
                    commit('addMenuitemToOrden', orderList)
                    let infoTodayDo = calculateInfoToday(orderList)
                    commit('updateInfoToday', infoTodayDo);
                    return result
                },
                error =>{
                    console.log(error)
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    throw error
                }
            )
    },
    delItemMenuToOrden({dispatch, commit}, {idOrden,position}){
        return orderService.delSameItemMenuToOrden(idOrden,position)
            .then(
                result => {
                    const orderList = normalizeOrders(result.orders)
                    commit('delMenuitemInOrden', orderList)
                    let infoTodayDo = calculateInfoToday(orderList)
                    commit('updateInfoToday', infoTodayDo);
                    return result
                },
                error =>{
                    console.log(error)
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    throw error
                }
            )
    },
    sendOrderToKitchen({dispatch, commit}, {idOrden}){
        return orderService.sendOrderToKitchen(idOrden)
            .then(
                result => {
                    commit('setOrderKitchenStatus', {
                        idOrden,
                        status: {
                            sendKitchen: true,
                            preparing: false,
                            terminate: false,
                            delivered: false,
                            dateSendKitchen: new Date().toISOString(),
                        }
                    })
                    return result
                },
                error =>{
                    console.log(error)
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    throw error
                }
            )
    },
    deliverOrder({dispatch, commit}, {idOrden}){
        return orderService.deliverOrder(idOrden)
            .then(
                result => {
                    commit('setOrderKitchenStatus', {
                        idOrden,
                        status: {
                            delivered: true,
                            dateDelivered: new Date().toISOString(),
                        }
                    })
                    return result
                },
                error =>{
                    console.log(error)
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    throw error
                }
            )
    },
    deleteOrder({dispatch, commit}, {idOrden}){
        return orderService.deleteOrder(idOrden)
            .then(
                result => {
                    if(result && result.valid){
                        commit('removeOrderFromList', idOrden)
                    }
                    return result
                },
                error =>{
                    console.log(error)
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                    throw error
                }
            )
    },
    infoClientByNit({commit},payload){
        const nit = typeof payload === "string" ? payload : payload.nit;
        const params = typeof payload === "string" ? {} : (payload.params || {});
        console.log(nit)
        return orderService.getInfoClientByNIT(nit, params)
            .then(
                result => {
                    commit('setInfoClientSAT', result.client)
                    return result
                }
            )
    },
    requestPayment({ commit}, {idOrden, requestData}){
        return Swal.fire({
            title: "¿Hacer cobro?",
            showCancelButton: false,
            confirmButtonText: "Realizar compra",
            showLoaderOnConfirm: true,
            showCloseButton:false,
            preConfirm: async () => {
                try {
                    console.log(requestData)
                    let doMakePayment = await orderService.makePayment(idOrden, requestData)
                    console.log(doMakePayment)
                    return doMakePayment
                    /*
                    .then(
                        result => {
                            console.log(result)
                            if(result.valid){
                                commit('setOrderToCheckout', result.orderUpdated)
                                commit('paymentResult', result)
                                Swal.fire({
                                    position:"center",
                                    icon: "success",
                                    title: "Compra realizada.",
                                    showConfirmButton: false,
                                    timer: 2000
                                });
                                return true
                            }else{
                                return false
                            }
                        },
                        error =>{
                            console.log(error)
                            commit('noAction', error);
                            dispatch('notification/error', error, { root: true });
                        }
                    )
                        */
                } catch (error) {
                    Swal.showValidationMessage(`
                    Hubo un error en el cobro, comunicarse con soporte: ${error}
                    `);
                    return false
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result)
            if (result.value.valid) {
                commit('setOrderToCheckout', result.value.orderUpdated)
                commit('paymentResult', result.value)
                Swal.fire({
                    position:"center",
                    icon: "success",
                    title: result.value.msg || "Compra realizada.",
                    showConfirmButton: false,
                    timer: 2000
                });
            }else{
                const paymentInfo = result.value && result.value.paymentInfo ? result.value.paymentInfo : {};
                Swal.fire({
                    position:"center",
                    icon: "warning",
                    title: result.value && result.value.msg ? result.value.msg : `Compra no realizada. Revisar información enviada. ${paymentInfo.findError || ""}`,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    //toast:true
                    //timer: 2000
                });
                commit('setOrderToCheckout', result.value.orderUpdated)
                //commit('noAction', error);
                //dispatch('notification/error', error, { root: true });
            }
        });
    },
    requestPaymentNoCardPartial({dispatch, commit}, {idOrden, requestData}){
        return orderService.makePaymentNoCardPartial(idOrden, requestData)
            .then(
                result => {
                    console.log(result)
                    commit('setOrderToCheckout', result.orderUpdated)
                    //commit('paymentResult', result)
                    if(result.valid){
                        Swal.fire({
                            position:"center",
                            icon: result.efactInfo && result.efactInfo.valid === false && requestData.factura === true ? "warning" : "success",
                            title: result.msg || "Compra efectuada.",
                            showConfirmButton: false,
                            timer: 2400
                        });
                    }else{
                        Swal.fire({
                            position:"center",
                            icon: "warning",
                            title: result.msg || "No se pudo registrar el pago.",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                    }
                },
                error =>{
                    console.log(error)
                    commit('noAction', error);
                    dispatch('notification/error', error, { root: true });
                }
            )
    },
    requestSetToPrint({dispatch, commit}, {idOrden, dataOrder}){
        console.log(idOrden, dataOrder)
        orderService.makeSetToPrint(idOrden)
            .then(
                result => {
                    console.log(result)
                    //commit('setOrderToCheckout', result.orderUpdate)
                    //commit('paymentResult', result)
                    
                    Swal.fire({
                        position:"center",
                        icon: "success",
                        title: `La orden ${dataOrder.idOrderString} está lista para imprimir.`,
                        showConfirmButton: false,
                        timer: 1500
                    });
                },
                error =>{
                    console.log(error)
                    commit('noAction', error);
                    dispatch('notification/error', error, { root: true });
                }
            )
    },
    setOrderToPay({commit}, {order}){
        console.log(order)
        commit('setOrderToCheckout', order)
    },
    requestDoFel({commit}, {idOrden, body}){
        Swal.fire({
            title: "¿Crear factura?",
            showCancelButton: false,
            confirmButtonText: "Sí, crear",
            showLoaderOnConfirm: true,
            showCloseButton:false,
            preConfirm: async () => {
                try {
                    let felReq = orderService.makeDoFel(idOrden, body)
                    console.log(felReq)
                    return felReq
                } catch (error) {
                    Swal.showValidationMessage(`
                    Hubo un error en la creación de factura, comunicarse con soporte: ${error}
                    `);
                    return false
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result)
            if (result.value.valid) {
                commit('setOrderToCheckout', result.value.orderUpdated)
                //commit('paymentResult', result.value)
                Swal.fire({
                    position:"center",
                    icon: "success",
                    title: "La factura ha sido creada.",
                    showConfirmButton: false,
                    timer: 2000
                });
            }else{
                Swal.fire({
                    position:"center",
                    icon: "warning",
                    title: `Error - ${result.value.msg}`,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
                commit('setOrderToCheckout', result.value.orderUpdated)
            }
        });
    },
};

export const mutations = {
    ordersRequest(state, orders){
        state.status = { ordersReq: true },
        state.orders = normalizeOrders(orders)
    },
    ordersRequestFail(state) {
        state.status = { ordersReq: false};
        state.orders = [];
    },
    ordersRequestNew(state, orders){
        state.status = { orderNew: true}
        state.orders = normalizeOrders(orders)
    },
    ordersRequestNewFail(state){
        state.status = { orderNew: false}
    },
    itemsMenuList(state, items){
        state.itemsMenu = items
    },
    loginFailure(state) {
        state.orders = {};
        state.itemsMenu = null;
    },
    addMenuitemToOrden(state, orders){
        state.orders = normalizeOrders(orders)
    },
    delMenuitemInOrden(state, orders){
        state.orders = normalizeOrders(orders)
    },
    setOrderKitchenStatus(state, {idOrden, status}){
        state.orders = normalizeOrders(state.orders).map((order) => {
            if(order._id !== idOrden){
                return order
            }

            return {
                ...order,
                ...status
            }
        })
    },
    removeOrderFromList(state, idOrden){
        state.orders = normalizeOrders(state.orders).filter((order) => order._id !== idOrden)
        state.todayInfo = calculateInfoToday(state.orders)
    },
    setInfoClientSAT(state, infoClient){
        state.client = infoClient
    },
    noAction(){

    },
    paymentResult(state, resultDoPayment){
        state.paymentResult = resultDoPayment
    },
    setOrderToCheckout(state, order){
        console.log(order)
        state.payOrder = {...order}
    },
    updateInfoToday(state, info){
        state.todayInfo= {...info}
    },
    setLoading(state,flag){
        state.loadingFlag = flag
    },
};
